'use strict';

/*global isEmpty*/
/*global services*/

(function ($) {
    var $btn = null;

    var methods = {
        init: function (/*options*/) {
            return this.each(function () {
                var _this = this;
                var $this = $(this);

                if ($this.hasClass('form-filtering-init')) {
                    return;
                }

                $this.addClass('form-filtering-init');

                $this.on('click', 'button[type="reset"]', function (e) {
                    methods.reset.apply(_this, e);
                    return false;
                });
            });
        },

        reset: function () {
            var _this = this;

            $(this).find('.filter-row').find('input').val('');
            $(this).submit();

            return _this;
        }
    };

    $.fn.FormFiltering = function (methodOrOptions) {
        if (methods[methodOrOptions]) {
            return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
            return methods.init.apply(this, arguments);
        } else {
            $.error('Method ' + methodOrOptions + ' does not exists on jQuery.FormFiltering');
        }
    };

    $.fn.FormFiltering.defaults = {};
})(jQuery);
